import React from 'react';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';

interface FAQSearchProps {
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

const FAQSearch: React.FC<FAQSearchProps> = ({ value, onChange, className = '' }) => {
  return (
    <div className={`relative ${className}`}>
      <div className="relative">
        <MagnifyingGlassIcon 
          className="absolute left-4 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400"
        />
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Search frequently asked questions..."
          className="w-full pl-12 pr-4 py-4 border border-gray-200 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-airbnb-red focus:border-transparent placeholder-gray-400 transition-shadow duration-200"
        />
      </div>

      {value && (
        <button
          onClick={() => onChange('')}
          className="absolute right-4 top-1/2 transform -translate-y-1/2 text-sm text-gray-500 hover:text-gray-700 transition-colors duration-200"
        >
          Clear
        </button>
      )}
    </div>
  );
};

export default FAQSearch;